import ProductGroup from './product-group'
export default ProductGroup;